"use client";

import theme from "@/themes/velys-theme";
import React from "react";

export default function CaseDataLoader({
  percent,
  size,
  color,
}: {
  percent: number | null;
  size: string;
  color?: string;
}) {
  return percent != null ? (
    <svg width={size} height={size} viewBox="0 0 100 100">
      <circle
        cx="50"
        cy="50"
        r="40"
        stroke="#ddd"
        strokeWidth="8"
        fill="none"
      />
      <circle
        cx="50"
        cy="50"
        r="40"
        stroke={color ? color : theme.main}
        strokeWidth="8"
        fill="none"
        strokeDasharray={Math.PI * 2 * 40}
        strokeDashoffset={(1 - percent / 100) * Math.PI * 2 * 40}
        strokeLinecap="round"
        transform="rotate(-90 50 50)"
      />

      <text
        x="50"
        y="50"
        textAnchor="middle"
        dy="0.35em"
        fontSize="28"
        fontWeight="bold"
        fill="#000"
        className="johnson-display"
      >
        {Math.round(percent)}%
      </text>
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      style={{
        animation: "spin 1s linear infinite",
        transformOrigin: "center",
      }}
    >
      <circle
        cx="20"
        cy="20"
        r="16"
        stroke={color ? color : theme.main}
        strokeWidth="4"
        fill="none"
        strokeLinecap="round"
        strokeDasharray="80 40"
      />
      <style>
        {`
      @keyframes spin {
        100% { transform: rotate(360deg); }
      }
    `}
      </style>
    </svg>
  );
}
